import { useState } from "react";
import { Icon, Menu } from "@astrum/ui";
import { isDesktop } from "../lib/transport.js";

/**
 * Installers for the desktop app, served by the site itself from
 * packages/web/public/downloads — the GitHub releases are private, so a link
 * there would 404 for everyone outside the repo. The names are fixed across
 * versions so these links never go stale; the desktop app loads the live site,
 * so an installer only needs replacing when the app shell itself changes.
 */
const DESKTOP_DOWNLOADS = {
  mac: "/downloads/AstrumConnect-mac.dmg",
  windows: "/downloads/AstrumConnect-windows-setup.exe",
} as const;

function startDownload(href: string) {
  const a = document.createElement("a");
  a.href = href;
  a.download = "";
  document.body.append(a);
  a.click();
  a.remove();
}

/** Rail control offering the desktop installers. Hidden inside the desktop app itself. */
export function DownloadApps({ expanded }: { expanded: boolean }) {
  const [open, setOpen] = useState(false);
  if (isDesktop) return null;

  return (
    <Menu
      open={open}
      onClose={() => setOpen(false)}
      align="side"
      label="Astrum Connect desktop"
      items={[
        {
          id: "mac",
          label: "Download for Mac",
          description: "Universal — Apple Silicon & Intel",
          icon: "download",
          onSelect: () => startDownload(DESKTOP_DOWNLOADS.mac),
        },
        {
          id: "windows",
          label: "Download for Windows",
          description: "Windows 10 / 11 (.exe)",
          icon: "download",
          onSelect: () => startDownload(DESKTOP_DOWNLOADS.windows),
        },
      ]}
    >
      <button
        type="button"
        className="shell-rail-action"
        aria-label="Download the desktop app"
        title={expanded ? undefined : "Download the desktop app"}
        onClick={() => setOpen((o) => !o)}
      >
        <Icon name="download" size={18} />
        {expanded && <span className="shell-nav-label">Download app</span>}
      </button>
    </Menu>
  );
}
